import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter } from '../../../global/commonStyle';

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  background: var(--background-secondary);
  gap: var(--space-8);
  z-index: var(--z-index-99);
  ${mobile_xl(css`
    display: grid;
    grid-template-columns: repeat(1, 2fr);
    width: calc(100vw - 40px);
    padding: var(--space-8) var(--space-20) var(--space-4);
  `)}
`;

const TeamTimeLine = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-12);
`;

const TimeLineCard = styled.div`
  display: flex;
  margin-inline: var(--space-24);
  padding-block: var(--space-20) var(--space-24);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-18);
  ${mobile_xl(css`
    padding-bottom: var(--space-96);
  `)}
`;

const ActivityTextDiv = styled.div`
  ${AlignCenter}
  align-content: center;
  padding-block: var(--space-3);
  column-gap: var(--space-4);
  flex-wrap: wrap;
  p {
    ${Typography.body_md_medium}
    color: var(--text-primary);
    margin: var(--space-0);
  }
  span {
    ${Typography.body_md};
    color: var(--text-secondary);
    margin: var(--space-0);
  }
`;

const Title = styled.p`
  ${Typography.body_sm_medium};
  color: var(--text-secondary);
  margin: var(--space-0);
`;

const StatusIcon = styled.div`
  ${FlexCenter}
  border-radius: var(--border-radius-full);
  background-color: var(--neutral-secondary);
  margin-left: -5px;
  z-index: var(--z-index-base);
  svg {
    padding: var(--space-5);
  }
`;
const ProfileDiv = styled.div`
  ${AlignCenter}
`;
const ActivityItem = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
`;

const ActivityContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-8);
`;

const RightSection = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
  ${mobile_xl(css`
    flex-direction: column;
  `)}
`;

const RangeSelectionSection = styled.div`
  max-width: 336px;
  width: 100%;
  position: relative;
  ${FlexCenter}
  .custom-dropdown {
    border-color: var(--border-primary);
    border-radius: var(--border-radius-8) var(--border-radius-0) var(--border-radius-0) var(--border-radius-8);
    width: max-content;
    ${mobile_xl(css`
      width: unset;
    `)}
  }
  .calendar-dropdown {
    border-color: var(--border-primary);
    border-radius: var(--border-radius-0) var(--border-radius-8) var(--border-radius-8) var(--border-radius-0);
    width: max-content;
    box-shadow: var(--top-right-border), var(--bottom-border);
    &:hover {
      box-shadow: var(--top-right-border), var(--bottom-border);
    }
    ${mobile_xl(css`
      width: unset;
    `)}
  }
  .dropdown-icon {
    transform: rotate(180deg);
  }
  ${mobile_xl(css`
    max-width: calc(100vw - 40px);
    display: grid;
    grid-template-columns: 0.93fr 1.07fr;
  `)}
`;

const ButtonComponent = styled.div`
  width: 100%;
  ${FlexCenter}
`;

export {
  Heading,
  Content,
  TeamTimeLine,
  TimeLineCard,
  ActivityTextDiv,
  Title,
  StatusIcon,
  ProfileDiv,
  ActivityItem,
  ActivityContentDiv,
  RangeSelectionSection,
  RightSection,
  ButtonComponent
};
